import http from 'plugins/axios';

export default {
  getList(data) {
    return http.get({
      url: '/la/admin/select/user/divdends',
      data
    });
  },
  getCoinTypeList() {
    return http.get({
      url: '/la/admin/coin/allDisplay'
    });
  },
  create(data) {
    return http.post({
      url: '/la/admin/get/user/divdends',
      data,
      dataType: 'form'
    });
  },
  update(data) {
    return http.post({
      url: '/la/admin/update/user/divdends',
      data
    });
  },
  deletes(data) {
    return http.post({
      url: '/la/admin/delete/user/divdends',
      data
    });
  },
  startDivident(data) {
    return http.post({
      url: '/la/admin/set/totalabonus',
      data
    });
  },
  endDivident(data) {
    return http.post({
      url: '/la/admin/delete/totalabonus',
      data
    });
  },
  Onestart(data) {
    return http.post({
      url: '/la/admin/set/singleabonus',
      data,
      dataType: 'form'
    });
  }
};
